import GenericIndex from 'client/js/resellercp/generic_resource/index';
import { BasicDropdown } from 'client/js/usercp/table_utils';
import { FaIcon } from 'client/js/util/layout_utils';
import { Link } from 'react-router-dom';
import {AnimatedTabs, AnimatedNavItem as NavItem} from 'client/js/util/nav_tabs';

const Header = () => {
  return (
    <tr>
      <th>Datenbank</th>
      <th>Backup vom</th>
      <th>Status</th>
      <th>Größe</th>
      <th>Optionen</th>
    </tr>
  )
}

const TableRow = (props) => {
  const backup = props.item;

  const download_button = <Link to={`/database_backups/${backup.id}/restore`} className="btn btn-light"><FaIcon name="undo" /> wiederherstellen</Link>;

  return (
    <tr key={backup.id}>
      <td><Link to={`/databases/${backup.database_id}`}>{backup.database_name}</Link></td>
      <td>{dayjs(backup.created_at).format('L LT')}</td>
      <td>{i18n_t(`resources.database_backups.state.${backup.state}`)}</td>
      <td>{format_disk_space(backup.size)}</td>
      <td>
        <BasicDropdown button={download_button}>
          <a href={`/usercp/database_backups/${backup.id}/download`} className="dropdown-item">herunterladen</a>
        </BasicDropdown>
      </td>
    </tr>
  );
}

const tabs = (
    <AnimatedTabs>
      <NavItem to="/webspace_backups">Webspace-Backups</NavItem>
      <NavItem to="/database_backups">Datenbank-Backups</NavItem>
      <NavItem to="/restores">Restores</NavItem>
    </AnimatedTabs>
  )

const Index = () => (<GenericIndex namespace="usercp"
  resource_name="database_backups"
  tabs={tabs}
  table_header={Header}
  row={TableRow}
  no_create />);

export default Index;
